import { defineMessages } from 'react-intl';

export default defineMessages({
  formTitle: {
    id: 'formTitle',
    defaultMessage: 'RNA Tube Order Entry'
  },
  formNote: {
    id: 'formNote',
    defaultMessage: 'Note: You can save your work in progress by clicking Add to Cart.'
  },
  formInstructions: {
    id: 'formIstructions',
    defaultMessage: 'formInstruction'
  },
  instructionOne: {
    id: 'instructionOne',
    defaultMessage: 'instructionOne'
  },
  instructionTwo: {
    id: 'instructionTwo',
    defaultMessage: 'instructionTwo {instructionTwoContent}'
  },
  instructionTwoContent: {
    id: 'instructionTwoContent',
    defaultMessage: 'instructionTwoContent'
  }
});
